<template>
  <div class="flex justify-between items-start">
    <div class="slider relative">
      <div class="flex justify-between">
        <span class="range-label bold-label">{{label}}</span>
      </div>
      <div class="range">
        <b-form-input class="range__input"
          type="range"
          v-model="value"
          :disabled="disabled"
          :id="id"
          :min="rangeMin"
          :max="rangeMax"
          :step="0.05"
          @change="emitValue">
        </b-form-input>
        <span class="range__fill"
          :style="{ width: `${percentValue}%` }">
        </span>
      </div>
      <div v-if="showValueLabels" class="flex justify-between">
        <span class="range-label bold-label">{{minLabel}}</span>
        <span class="range-label bold-label">{{data.maxLabel}}</span>
      </div>
    </div>
    <div class="display-value alert alert-success p-2 ml-4">
      <Currency
        v-if="data.displayValueType === 'currency'"
        :value="displayValue"
      />
      <div v-else class="font-bold text-lg">{{displayValue}}</div>
    </div>
  </div>
</template>

<script>
import Currency from './Currency.vue';

export default {
  props: {
    id: String,
    data: Object,
    type: {
      type: String,
      default: 'percent',
      validator: (val) => ((val !== 'value') ? 'percent' : val),
    },
    label: String,
    labelPosition: {
      type: String,
      default: 'below',
      validator: (val) => ((val !== 'above') ? 'below' : val),
    },
    showValueLabels: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
  },

  components: {
    Currency,
  },

  data() {
    return {
      minLabel: this.data.minLabel,
      minValue: this.data.minValue,
      maxLabel: this.data.maxLabel,
      maxValue: this.data.maxValue,
      value: this.data.value,
    };
  },

  computed: {
    rangeMin() {
      return (!this.minValue || this.type === 'percent') ? 0 : this.minValue;
    },

    rangeMax() {
      return (!this.maxValue || this.type === 'percent') ? 100 : this.maxValue;
    },

    displayValue() {
      return (this.data.displayValueType === 'percent')
        ? `${Number(this.value).toFixed(this.data.valueDecimals)}%`
        : Number(this.value).toFixed(this.data.valueDecimals);
    },

    percentValue() {
      const {
        value,
        rangeMax,
        rangeMin,
      } = this;

      return (((Number(value) - rangeMin) * 100) / (rangeMax - rangeMin));
    },
  },

  methods: {
    emitValue(value) {
      this.$emit('change', {
        prop: this.data.prop,
        key: this.data.key,
        value,
      });
    },
  },
};
</script>
